import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface Workspace {
  workspaceId: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: {
    id: string;
    name: string;
    email: string;
    avatarUrl: string | null;
  };
  memberCount: number;
  glossaryCount: number;
}

export interface CreateWorkspaceData {
  name: string;
  description?: string;
}

export interface UpdateWorkspaceData {
  name?: string;
  description?: string | null;
}

export async function fetchMyWorkspaces() {
  const res = await api.get<ApiResponse<Workspace[]>>('/workspaces');
  return res.data.data!;
}

export async function fetchWorkspace(workspaceId: string) {
  const res = await api.get<ApiResponse<Workspace>>(`/workspaces/${workspaceId}`);
  return res.data.data!;
}

export async function createWorkspace(data: CreateWorkspaceData) {
  const res = await api.post<ApiResponse<Workspace>>('/workspaces', data);
  return res.data.data!;
}

export async function updateWorkspace(workspaceId: string, data: UpdateWorkspaceData) {
  const res = await api.put<ApiResponse<Workspace>>(`/workspaces/${workspaceId}`, data);
  return res.data.data!;
}

export async function deleteWorkspace(workspaceId: string) {
  await api.delete(`/workspaces/${workspaceId}`);
}
